import { render } from "./ProductRequestModal.vue?vue&type=template&id=7384c2d5&scoped=true"
import script from "./ProductRequestModal.vue?vue&type=script&lang=js"
export * from "./ProductRequestModal.vue?vue&type=script&lang=js"

import "./ProductRequestModal.vue?vue&type=style&index=0&id=7384c2d5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7384c2d5"]])

export default __exports__